<template>
    <vForm :label-width="90" inline >
        <vFormItem :label="$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'})" style="width:92%">
            <vSelect  v-model="carrierCode" filterable @on-change="changeCarrier(carrierCode)">
                <vOption v-for="item in getCarrierServiceList" :value="item.attach.carrierCode" :key="item.value">{{item.label}}</vOption>
            </vSelect>
        </vFormItem>
        <compUpload v-bind="getFileProps" @on-close="close"></compUpload>
    </vForm>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    components: {
		compUpload: () => import("@components/templates/upload"),
	},
    data(){
        return {
            carrierCode:'',
            carrierServiceCode:'',
            labelValue:"",
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getCarrierServiceList']),
        getFileProps() {
			return {
				action: process.env.VUE_APP_APIURL_FBB + '/api/v2/fedexBaseCost/importFedex',
				name: "multipartFile",
				data: {
					carrierCode: this.carrierCode,
					carrierServiceCode: this.carrierServiceCode,
				},
                // accept: this.fileType === 'Other' ? '' : 'image/*,application/pdf',
                download:()=>{
                    this.handleWebfs("/static/template/FedEx_basecost.xlsx", {}, {
                        executor: 'download',
                        type: 'url'
                    });
                    // this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/warehouseStorage/warehouseStorageTemplate", {}, 'download')
                }
			}
		},
    },
    methods: {
        changeCarrier(value){
            // console.log(value)
            const onelist = this.getCarrierServiceList.filter(item=>{
                 return value == item.attach.carrierCode
            })
            this.carrierServiceCode = onelist[0].attach.carrierServiceCode
        },
        close(){
            this.$emit('on-close')
        }
    }
}
</script>
